import Section from "../../section/Section";
import socialEnterpriseLogo from "@images/v2/social-enterprise-small.svg";
import Image from "../../Image";

export default function SocialLinks() {
	return (
		<Section className="pb-6 pb-md-11 border-bottom border-dark">
			<ul id="social-links" className="list-unstyled my-0 py-0 pl-0 pr-0 d-flex align-items-center flex-wrap">
				<li className="pr-1 pb-3">
					<a
						href="https://www.linkedin.com/company/stay-nimble/"
						target="_blank"
						rel="noreferrer"
						className="btn btn-light-green btn-cornered font-size-lg font-weight-normal"
					>
						LinkedIn
					</a>
				</li>
				<li className="px-1 pb-3">
					<a
						href="https://podcasters.spotify.com/pod/show/staynimble"
						target="_blank"
						rel="noreferrer"
						className="btn btn-purple font-size-lg border border-dark font-weight-normal"
					>
						Podcast
					</a>
				</li>
				<li className="px-1 pb-3">
					<a
						href="https://uk.trustpilot.com/review/staynimble.co.uk"
						target="_blank"
						rel="noreferrer"
						className="btn btn-mid-green font-size-lg btn-cornered font-weight-normal"
					>
						{/*// TODO add icon here*/}
						{/*<Icon name="rating-star" filled={false} style={{ width: 12 }} />*/}
						<span>Trustpilot</span>
					</a>
				</li>
				<li className="px-1 pb-3">
					<a
						href="https://twitter.com/StayNimble"
						target="_blank"
						rel="noreferrer"
						className="btn btn-white btn-cornered font-size-lg border border-dark font-weight-normal"
					>
						Twitter
					</a>
				</li>
				<li className="px-1 pb-3">
					<a
						href="https://www.instagram.com/staynimblecareers/"
						target="_blank"
						rel="noreferrer"
						className="btn btn-pink btn-cornered font-size-lg border border-dark font-weight-normal"
					>
						Instagram
					</a>
				</li>
				<li className="px-1 pb-3">
					<a
						href="https://www.youtube.com/@staynimble9917"
						target="_blank"
						rel="noreferrer"
						className="btn btn-red btn-cornered font-size-lg border border-dark font-weight-normal"
					>
						Youtube
					</a>
				</li>
				<li className="px-1 pb-3">
					<a
						href="https://www.facebook.com/staynimble"
						target="_blank"
						rel="noreferrer"
						className="btn btn-dark-purple btn-cornered font-size-lg border border-dark font-weight-normal"
					>
						Facebook
					</a>
				</li>

				<li className="ml-auto d-none d-md-block">
					<Image
						src={socialEnterpriseLogo}
						alt="Social Enterprise"
						className=""
						width={34}
						height={34}
						responsive={false}
					/>
				</li>
			</ul>
		</Section>
	);
}
